import script from "./QСounterpartiesItemAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./QСounterpartiesItemAdmin.vue?vue&type=script&setup=true&lang=js"

import "./QСounterpartiesItemAdmin.vue?vue&type=style&index=0&id=4c88bbe5&lang=scss&scoped=true"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c88bbe5"]])

export default __exports__